import { Component, Input } from "@angular/core";
import { Params } from "@angular/router";

export type CardVariant = "feature" | "sale" | "design" | "bestseller";
export interface CategoryCard {
    title: string;
    description: string;
    image: string;
    target: string;
    queryParams?: Params;
    variant: CardVariant;
}

@Component({
    selector: "app-category-card",
    templateUrl: "./category-card.component.html",
    styleUrl: "./category-card.component.scss",
    standalone: false,
})
export class CategoryCardComponent {
    @Input() title: string = "";
    @Input() description: string = "";
    @Input() image: string = "";
    @Input() target: string = "";
    @Input() queryParams?: Params;
    @Input() variant!: CardVariant;

    getCardClasses(): string {
        const baseClasses = "card-variant";
        switch (this.variant) {
            case "sale":
                return `${baseClasses} card-sale`;
            case "design":
                return `${baseClasses} card-design`;
            case "bestseller":
                return `${baseClasses} card-bestseller`;
            default:
                return `${baseClasses} card-feature`;
        }
    }
}
